import { render } from "./LastStep.vue?vue&type=template&id=4a4b69c2&scoped=true&ts=true"
import script from "./LastStep.vue?vue&type=script&lang=ts"
export * from "./LastStep.vue?vue&type=script&lang=ts"

import "./LastStep.vue?vue&type=style&index=0&id=4a4b69c2&scoped=true&lang=scss"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4b69c2"]])

export default __exports__